import React, { ChangeEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  CardMedia,
  Input,
  TextField,
  MenuItem,
  Select
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import CloseIcon from "@mui/icons-material/Close";
import "react-phone-input-2/lib/bootstrap.css";

const EditUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAddUser = location.pathname === "/manage-users/add";

  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [gender, setGender] = React.useState("default");

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>{isAddUser ? "Add" : "Edit"} Customer</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>
            Customer Management
          </button>{" "}
          - {isAddUser ? "Add" : "Edit"} Customer
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">

            {/* UPLOAD IMAGE */}
            <div className="control_group w_100">
              <label>Upload Image</label>

              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="User" />
                    </figure>
                    <CloseIcon
                      className="remove_img"
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="upload-user-image">
                  <Input
                    sx={{ display: "none" }}
                    id="upload-user-image"
                    type="file"
                    inputProps={{ accept: "image/png,image/jpeg" }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = event.target.files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="User"
                      />
                      <span className="upload_img_icon">
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            {/* FULL NAME */}
            <div className="control_group w_33">
              <label>Full Name</label>
              <TextField placeholder="Enter Full Name" hiddenLabel fullWidth />
            </div>

            {/* EMAIL */}
            <div className="control_group w_33">
              <label>Email</label>
              <TextField
                type="email"
                placeholder="Enter Email"
                hiddenLabel
                fullWidth
              />
            </div>

            {/* PHONE */}
            <div className="control_group w_33">
              <label>Phone Number</label>
              <PhoneInput
                country="in"
                placeholder="Enter Phone Number"
                inputStyle={{ width: "100%" }}
                enableSearch={false}
              />
            </div>

            {/* GENDER */}
            <div className="control_group w_33">
              <label>Gender</label>
              <Select
                fullWidth
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <MenuItem value="default" disabled>
                  Select Gender
                </MenuItem>
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </div>

            {/* COUNTRY */}
            <div className="control_group w_33">
              <label>Country</label>
              <TextField placeholder="Enter Country" hiddenLabel fullWidth />
            </div>

            {/* STATE */}
            <div className="control_group w_33">
              <label>State</label>
              <TextField placeholder="Enter State" hiddenLabel fullWidth />
            </div>

            {/* CITY */}
            <div className="control_group w_33">
              <label>City</label>
              <TextField placeholder="Enter City" hiddenLabel fullWidth />
            </div>
          </div>

          {/* SAVE BUTTON */}
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
